<template>
  <v-card style="height: 100%">
    <div class="card-body">
      <v-responsive :aspect-ratio="1">
        <div
          style="
            background-color: #eee;
            height: 100%;
            background-position: center;
            background-size: cover;
          "
          :style="{
            backgroundImage:
              'url(\'' +
              productImages[0] +
              '\'),url(\'/static/img/assets/_global/default-photo.png\')'
          }"
        ></div>
      </v-responsive>
      <template>
        <div style="position: relative">
          <div class="action" style="position: absolute; top: -20px; left: 0; right: 0px">
            <v-layout>
              <v-flex class="px-2">
                <label class="toggle-switch small ma-1" style="vertical-align: bottom">
                  <input
                    type="checkbox"
                    v-model="status"
                    :checked="status"
                    @change="toggleProductStatus(product)"
                  />

                  <span class="toggle-slider lever round"></span>
                </label>
              </v-flex>
              <v-flex class="text-xs-right px-2">
                <v-btn
                  fab
                  depressed
                  color="primary"
                  small
                  class="extra-small ma-1"
                  @click="$emit('onSelectedProduct')"
                  v-if="
                    !(
                      selectedBot.useketshop == true &&
                      selectedBot.ketshop_api_key &&
                      selectedBot.ketshop_api_secret
                    )
                  "
                >
                  <em class="fa fa-pencil-alt middle" />
                </v-btn>
                <!-- <v-btn
                  fab
                  depressed
                  color="primary"
                  small
                  class="extra-small ma-1"
                  @click="onDeleteProduct(product.id)"
                  v-if="
                    !(
                      selectedBot.useketshop == true &&
                      selectedBot.ketshop_api_key &&
                      selectedBot.ketshop_api_secret
                    )
                  "
                >
                  <em class="fa fa-trash middle"/>
                </v-btn> -->
              </v-flex>
            </v-layout>
          </div>
          <div style="padding: 15px; border-bottom: 1px solid #eee">
            <div class="name" :title="product.name">{{ product.name | truncate(20) }}</div>
            <div class="price primary--text title">
              <!-- <template v-if="discountPriceRange != priceRange">{{ discountPriceRange }}</template>
              <template v-else>{{ priceRange }}</template> -->
              <!-- <template>{{ priceRange }}</template> -->
            </div>
            <!-- <div
              class="discount grey--text text--lighten-1 caption"
              v-if="discountPriceRange != priceRange"
            >
              {{ priceRange }}
            </div> -->
            <!-- <div v-else class="discount caption">&nbsp;</div> -->
            <div class="discount caption">&nbsp;</div>
          </div>
        </div>

        <!-- <div style="overflow-y: auto; height: 100px" class="px-2 py-2">
          <template v-if="productstock && productstock.length > 0">
            <stock-item
              v-for="(stock, sindex) in productstock"
              :key="'stock_' + stock[0]"
              v-model="productstock[sindex]"
              :productId="product.id"
            ></stock-item>
          </template>
          <template v-else>
            <div class="text-xs-center">No stock</div>
          </template>
        </div> -->
      </template>
    </div>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex'
import api from '@/api'
import StockItem from './StockItem.vue'
import ModalEditProduct from './ModalEditProduct'
import ModalShareLink from './ModalShareLink'

export default {
  props: ['value', 'category', 'selectCategory'],
  data: function () {
    return {
      product: this.value,
      showModal: false,
      showLink: false,
      status: !this.value.hiddenstatus
    }
  },
  components: {
    ModalEditProduct,
    StockItem,
    ModalShareLink
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    productImages: function () {
      if (this.product.photo_url) {
        return this.product.photo_url.split(';;')
      } else if (this.product.photourl) {
        return this.product.photourl.split(';;')
      } else {
        return ''
      }
    },
    currencySign: function () {
      return '฿'
    }

    // priceRange: function() {
    //   var min = 0
    //   var max = 0

    //   for (let index = 0; index < this.product.productstock.length; index++) {
    //     var price =
    //       this.product.productstock[index][3] == null || this.product.productstock[index][3] == ''
    //         ? parseFloat(this.product.price)
    //         : parseFloat(this.product.productstock[index][3])
    //     if (index == 0) {
    //       min = price
    //       max = price
    //     } else {
    //       if (price > max) {
    //         max = price
    //       }
    //       if (price < min) {
    //         min = price
    //       }
    //     }
    //   }

    //   if (min == max) {
    //     return this.currencySign + numeral(min).format('0,0.00')
    //   } else {
    //     return (
    //       this.currencySign +
    //       numeral(min).format('0,0.00') +
    //       ' - ' +
    //       this.currencySign +
    //       numeral(max).format('0,0.00')
    //     )
    //   }
    // },
    // discountPriceRange: function() {
    //   var min = 0
    //   var max = 0

    //   for (let index = 0; index < this.product.productstock.length; index++) {
    //     var price =
    //       this.product.productstock[index][3] == null || this.product.productstock[index][3] == ''
    //         ? parseFloat(this.product.discountprice)
    //         : parseFloat(this.product.productstock[index][3])
    //     var discountprice =
    //       this.product.productstock[index][4] == null || this.product.productstock[index][4] == ''
    //         ? price
    //         : parseFloat(this.product.productstock[index][4])

    //     if (index == 0) {
    //       min = discountprice
    //       max = discountprice
    //     } else {
    //       if (discountprice > max) {
    //         max = discountprice
    //       }
    //       if (discountprice < min) {
    //         min = discountprice
    //       }
    //     }
    //   }

    //   if (min == max) {
    //     return this.currencySign + numeral(min).format('0,0.00')
    //   } else {
    //     return (
    //       this.currencySign +
    //       numeral(min).format('0,0.00') +
    //       ' - ' +
    //       this.currencySign +
    //       numeral(max).format('0,0.00')
    //     )
    //   }
    // },
    // discountPercentage: function() {
    //   var max = 0

    //   for (let index = 0; index < this.product.productstock.length; index++) {
    //     var price =
    //       this.product.productstock[index][3] == null || this.product.productstock[index][3] == ''
    //         ? parseFloat(this.product.price)
    //         : parseFloat(this.product.productstock[index][3])
    //     var discountprice =
    //       this.product.productstock[index][4] == null || this.product.productstock[index][4] == ''
    //         ? price
    //         : parseFloat(this.product.productstock[index][4])

    //     if (index == 0) {
    //       max = ((price - discountprice) / price) * 100
    //     } else {
    //       var percent = ((price - discountprice) / price) * 100
    //       if (max < percent) {
    //         max = percent
    //       }
    //     }
    //   }

    //   return max
    // },
    // productstock: function() {
    //   return this.product.productstock.sort(function(a, b) {
    //     if (parseInt(a[6]) > parseInt(b[6])) {
    //       return 1
    //     } else if (parseInt(a[6]) < parseInt(b[6])) {
    //       return -1
    //     } else {
    //       return 0
    //     }
    //   })
    // }
  },
  methods: {
    // toggleProductStatus() {
    //   var vm = this
    //   var status = this.product.status
    //   var data = {
    //     id: this.product.id,
    //     status: !status
    //   }
    //   api.editProductStatus(data, function(error, response) {
    //     if (error) {
    //       console.error(error)
    //       return
    //     }
    //     vm.$emit('changeproductstatus', data)
    //   })
    // },
    toggleProductStatus(product) {
      let vm = this
      let objProduct = { ...product }
      var status = this.status

      Object.assign(objProduct, { hiddenstatus: !status })

      // console.log("objProduct: ",objProduct.hiddenstatus)

      return new Promise((resolve, reject) => {
        api.editProductKFC(
          {
            ...objProduct
          },
          function (error, response) {
            if (error) reject(error)

            // vm.$emit('changeproductstatus')
            resolve(response)
          }
        )
      })
    },
    close: async function () {
      let vm = this
      vm.showModal = false
      // $('body').removeClass('modal-open')
      await vm.$nextTick()
      vm.$emit('input', vm.product)
    },
    onDeleteProduct: function (id) {
      let vm = this
      vm.$swal
        .fire({
          title: vm.$t('Do you want to delete {name}?', {
            name: vm.product.name.replace(/\<|\>/g, '')
          }),
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: vm.$t('Confirm'),
          cancelButtonText: vm.$t('cancel'),
          reverseButtons: true
        })
        .then((result) => {
          if (result.value) {
            vm.$store.dispatch('loading')
            api.deleteProduct(id, function (error, response) {
              if (error) {
                vm.$store.dispatch('loading')
                console.error(error)
                return
              }

              vm.$emit('productDeleted')
              vm.$emit('close')
              vm.$store.dispatch('loading')
            })
          }
        })
    },
    isProductActive: function (hiddenstatus) {
      if (hiddenstatus) {
        return false
      } else {
        return 'checked'
      }
    }
  },
  watch: {
    value: function (newVal, oldVal) {
      if (newVal != oldVal) {
        // this.product = this.value
      }
    },
    showModal: function (newVal, oldVal) {
      if (newVal) {
        $('body').addClass('modal-open')
      } else {
        $('body').removeClass('modal-open')
      }
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/Productkfc.vue